<template>
  <div class="">
    <div class="mt-2" :style="{'margin-right':`${margin}px`}">
      <input @click="checkboxClicked" type="checkbox" :value="category.id" :id="`category_${category.id}`">
      <label class="mr-1" :for="`category_${category.id}`">{{ category.name }}</label>
    </div>

    <category :remove-category="removeCategory"
              :selected-category="selectedCategory"
              v-for="children in category.children" :margin="margin+15"
              :key="children.id"
              :category="children"/>

  </div>
</template>

<script>
export default {
  name: "category",
  props: ['category', 'margin', 'selectedCategory', 'removeCategory'],
  methods: {
    checkboxClicked(e) {
      const value = e.target.value;
      if (e.target.checked) {
        this.selectedCategory.push(value)
      } else {
        // remove value from selectedCategory
        this.removeCategory(value)
      }
    }
  }

}
</script>

<style scoped>

</style>